import * as RD from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { cn } from "./cn";

export const Dialog = RD.Root;
export const DialogTrigger = RD.Trigger;
export const DialogClose = RD.Close;

export function DialogContent({
  title,
  description,
  children,
  className,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <RD.Portal>
      <RD.Overlay className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0" />
      <RD.Content
        className={cn(
          "fixed left-1/2 top-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-lg border border-[var(--border)] bg-[var(--surface)] p-6 shadow-[var(--shadow-2)]",
          className,
        )}
      >
        <RD.Title className="text-lg font-semibold">{title}</RD.Title>
        {description && (
          <RD.Description className="mt-1 text-sm text-[var(--fg-muted)]">
            {description}
          </RD.Description>
        )}
        <div className="mt-4">{children}</div>
      </RD.Content>
    </RD.Portal>
  );
}
